export default {
  wrapper: {
    height: '40px',
    backgroundColor: '#fff',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: (theme) => `${theme.palette.grays.gray300}`,
    },

    '& .MuiInputBase-input': {
      padding: '10px 12px',
      fontSize: '0.875rem',
      backgroundColor: '#fff',
      color: (theme) => theme.palette.grays.gray700,
    },

    '&:hover': {
      '.MuiOutlinedInput-notchedOutline': {
        borderColor: (theme) => `${theme.palette.grays.gray300}`,
      },
      '& .MuiInputBase-input': {
        borderColor: (theme) => `${theme.palette.grays.gray300}`,
        color: (theme) => theme.palette.grays.gray700,
        backgroundColor: (theme) => `${theme.palette.grays.lightestGray}`,
      },
    },
    '&.Mui-focused': {
      '.MuiOutlinedInput-notchedOutline': {
        border: 1,
        borderColor: (theme) => `${theme.palette.grays.gray300}`,
      },
      '& .MuiInputBase-input': {
        backgroundColor: (theme) => `${theme.palette.grays.lightestGray}`,
      },
    },
    '&.Mui-error': {
      '.MuiOutlinedInput-notchedOutline': {
        boxShadow: (theme) => `${theme.customShadows.errorShadow}`,
        borderColor: (theme) => `${theme.palette.reds.codingRed200}`,
      },
      '&.Mui-focused': {
        backgroundColor: (theme) => `${theme.palette.grays.lightestGray}`,
      },
      '&:hover': {
        backgroundColor: (theme) => `${theme.palette.grays.lightestGray}`,
      },
    },
    '&.Mui-disabled': {
      opacity: 0.8,
      color: (theme) => theme.palette.grays.gray700,
      pointerEvents: 'none',

      '&:hover': {
        backgroundColor: 'transparent!important',
        pointerEvents: 'none',

        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: (theme) => `${theme.palette.grays.gray300}`,
        },
        '& .MuiInputBase-input': {
          backgroundColor: 'transparent',
        },
      },
    },
  },
};
